module.exports = __webpack_public_path__ + "img/violet_053.4512a407.png";